const getCookie = (key) => {
  // Split the cookies string into an array of individual cookies
  const cookies = document.cookie.split(';');

  // Loop through each cookie to find the one with the specified key
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    // Check if this cookie starts with the specified key
    if (cookie.startsWith(`${key}=`)) {
      // Extract and return the cookie value
      return cookie.substring(key.length + 1);
    }
  }

  // If the cookie with the specified key is not found, return null
  return undefined;
};

export default getCookie;
